<div class="flex flex-col gap-6" role="alertdialog">
  <h3 class="flex items-center gap-3 text-lg font-bold">Session inactive</h3>
  <p class="m-0">
    You have been inactive for more than {{ inactivityLabelMinutes }} minutes.
    Your session will end in
    <span aria-live="polite" class="inline-block min-w-[32px]">{{
      countdownLabel()
    }}</span>
    unless you continue.
  </p>

  <div class="flex justify-center items-center gap-4">
    <button
      type="button"
      class="normal-case h-10 min-h-[40px] rounded-full btn btn-primary min-w-[160px] text-base"
      [disabled]="locked()"
      (click)="onContinue()"
    >
      @if(locked()) { Logging out... } @else { Continue session }
    </button>
  </div>
</div>
